<script setup>
const props = defineProps({
    variant: {
        type: String,
        default: "dark",
    },
    placeholder: {
        type: String,
    },
});

const emit = defineEmits(["update:keyword", "cancelSearch"]);
const route = useRoute();

const keyword = ref("");

const search = () => {
    emit("update:keyword", keyword.value);
};

const cancelSearch = () => {
    keyword.value = "";
    emit("cancelSearch");
};

watch(keyword, (newVal) => {
    if (newVal === "") {
        emit("cancelSearch");
    }
});
</script>

<template>
    <div
        class="slt-focus-outline flex flex-1 items-center gap-[2.03vw] rounded-[18.32vw] px-[4.07vw] py-[3.05vw] xs:gap-[8px] xs:rounded-[72px] xs:px-[16px] xs:py-[12px] lg:h-[3.17vw] lg:gap-[0.79vw] lg:px-[1.32vw] 3xl:h-[61px] 3xl:gap-[15.2px] 3xl:px-[25.4px]"
        :class="{
            'bg-base-silver': variant === 'light',
            'bg-base-deepGrey': variant === 'dark',
        }"
    >
        <SvgSearch24
            class="h-[6.1vw] w-[6.1vw] cursor-pointer xs:h-[24px] xs:w-[24px] lg:h-[1.59vw] lg:w-[1.59vw] 3xl:h-[30.6px] 3xl:w-[30.6px]"
            :color="variant === 'light' ? '#000' : 'white'"
            @click="search"
            v-sendGAsignal="{
                event_category: route.path,
                event_label: 'search',
            }"
        />
        <input
            type="text"
            :placeholder="placeholder"
            class="w-full flex-1"
            :class="{
                'text-black placeholder:text-base-black-40':
                    variant === 'light',
                'text-white placeholder:text-base-white-50': variant === 'dark',
            }"
            v-model="keyword"
            @keyup.enter="search"
        />
        <SvgClose24
            v-show="keyword"
            class="h-[6.1vw] w-[6.1vw] cursor-pointer xs:h-[24px] xs:w-[24px] lg:h-[1.59vw] lg:w-[1.59vw] 3xl:h-[30.6px] 3xl:w-[30.6px]"
            :color="variant === 'light' ? '#bdbdbd' : '#FF6400'"
            @click="cancelSearch"
            v-sendGAsignal="{
                event_category: route.path,
                event_label: 'close search',
            }"
        />
    </div>
</template>
